'use client'

import { useState } from 'react'
import { IconArrowNarrowLeft, IconArrowNarrowRight } from '@tabler/icons-react'
import clsx from 'clsx'

import Magnifier from 'shared/ui/Gallery/Magnifier'

import styles from './Gallery.module.scss'

interface GalleryItem {
  original: string
  thumbnail: string
  originalTitle?: string
}

interface GalleryProps {
  images: GalleryItem[]
}

const asDisabled = (disabled: boolean) =>
  ({ disabled }) as React.HTMLAttributes<HTMLDivElement>

const Gallery = ({ images }: GalleryProps) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const imagesCount = images.length

  const handleSetPreviousImage = () => {
    setCurrentIndex(prev => prev - 1)
  }

  const handleSetNextImage = () => {
    setCurrentIndex(prev => prev + 1)
  }

  const showControls = imagesCount > 1

  return (
    <div className={styles.wrapper}>
      {showControls && (
        <>
          <div
            {...asDisabled(currentIndex === 0)}
            className={clsx(styles.arrow, {
              [styles.arrowDisabled]: currentIndex === 0
            })}
            onClick={handleSetPreviousImage}
          >
            <IconArrowNarrowLeft />
          </div>
          <div
            {...asDisabled(currentIndex >= imagesCount - 1)}
            className={clsx(styles.arrow, styles.arrowRight, {
              [styles.arrowDisabled]: currentIndex >= imagesCount - 1
            })}
            onClick={handleSetNextImage}
          >
            <IconArrowNarrowRight />
          </div>
        </>
      )}
      <Magnifier
        imagesCount={imagesCount}
        currentIndex={currentIndex}
        showControls={showControls}
        onPrevClick={handleSetPreviousImage}
        onNextClick={handleSetNextImage}
        src={images[currentIndex].original}
        alt={images[currentIndex]?.originalTitle || 'product image placeholder'}
      />
    </div>
  )
}

export default Gallery
